<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="userForm"
    (ngSubmit)="saveUser()"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-user-edit mr-2 text-3xl"></i>
        <div>
          <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
          <div class="text-600 mt-1">Keep identity, access, and scope in one clean form.</div>
        </div>
      </div>

      <p-fieldset legend="Identity" [toggleable]="true" class="mb-5">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  id="fullName"
                  type="text"
                  pInputText
                  formControlName="fullName"
                  placeholder="Enter full name"
                  class="w-full"
                />
                <label for="fullName">Full Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-envelope"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  id="email"
                  type="email"
                  pInputText
                  formControlName="email"
                  placeholder="Enter email address"
                  class="w-full"
                />
                <label for="email">Email</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-mobile"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  id="mobileNumber"
                  type="text"
                  pInputText
                  formControlName="mobileNumber"
                  placeholder="Enter mobile number"
                  class="w-full"
                />
                <label for="mobileNumber">Mobile Number</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-check-circle"></i></p-inputgroup-addon>
              <p-iftalabel>
                <p-select
                  id="status"
                  formControlName="status"
                  [options]="statusOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select status"
                  [showClear]="false"
                  styleClass="w-full"
                ></p-select>
                <label for="status">Status</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset legend="Access" [toggleable]="true" class="mb-5">
        <div class="grid formgrid p-fluid">
          <div class="field col-12">
            <div class="flex align-items-center justify-content-between gap-3 mb-3">
              <label class="font-medium block">Role</label>
              <small class="text-600">Only one role can be assigned.</small>
            </div>
            <div class="user-role-grid">
              <div class="user-role-option" *ngFor="let role of roles">
                <p-radioButton [inputId]="'role-' + role.id" formControlName="roleId" [value]="role.id"></p-radioButton>
                <label [for]="'role-' + role.id" class="user-role-label">
                  <span class="user-role-name">{{ role.roleName }}</span>
                  <small *ngIf="role.description" class="text-600 block mt-1">{{ role.description }}</small>
                </label>
              </div>
            </div>
          </div>

          <div class="field col-12">
            <div class="flex flex-wrap gap-4">
              <div class="flex align-items-center gap-2">
                <p-checkbox inputId="canChangeRebate" formControlName="canChangeRebate" [binary]="true"></p-checkbox>
                <label for="canChangeRebate" class="font-medium text-900">Can Change Rebate</label>
              </div>
              <div class="flex align-items-center gap-2">
                <p-checkbox inputId="canChangeClaim" formControlName="canChangeClaim" [binary]="true"></p-checkbox>
                <label for="canChangeClaim" class="font-medium text-900">Can Change Claim</label>
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset legend="Scope" [toggleable]="true" class="mb-2">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center justify-content-between gap-3 mb-2">
              <label for="businessUnits" class="font-medium block">Business Units</label>
              <p-button
                type="button"
                label="Select All"
                icon="pi pi-check-square"
                styleClass="p-button-text p-button-sm"
                (onClick)="selectAllBusinessUnits($event)"
              ></p-button>
            </div>
            <p-autoComplete
              id="businessUnits"
              formControlName="businessUnitSelections"
              [suggestions]="businessUnitSuggestions"
              (completeMethod)="searchBusinessUnits($event)"
              [multiple]="true"
              field="name"
              dataKey="id"
              placeholder="Search business units"
              styleClass="w-full"
              inputStyleClass="w-full"
              [showClear]="true"
              [dropdown]="false"
              [appendTo]="'body'"
              [minLength]="1"
            ></p-autoComplete>
          </div>

          <div class="field col-12 md:col-6">
            <div class="flex align-items-center justify-content-between gap-3 mb-2">
              <label for="business" class="font-medium block">Business</label>
              <p-button
                type="button"
                label="Select All"
                icon="pi pi-check-square"
                styleClass="p-button-text p-button-sm"
                (onClick)="selectAllBusiness($event)"
              ></p-button>
            </div>
            <p-autoComplete
              id="business"
              formControlName="businessSelections"
              [suggestions]="businessSuggestions"
              (completeMethod)="searchBusiness($event)"
              [multiple]="true"
              field="name"
              dataKey="id"
              placeholder="Search business"
              styleClass="w-full"
              inputStyleClass="w-full"
              [showClear]="true"
              [dropdown]="false"
              [appendTo]="'body'"
              [minLength]="1"
            ></p-autoComplete>
          </div>

          <div class="field col-12 md:col-6">
            <div class="flex align-items-center justify-content-between gap-3 mb-2">
              <label for="branches" class="font-medium block">Branches</label>
              <p-button
                type="button"
                label="Select All"
                icon="pi pi-check-square"
                styleClass="p-button-text p-button-sm"
                (onClick)="selectAllBranches($event)"
              ></p-button>
            </div>
            <p-autoComplete
              id="branches"
              formControlName="branchSelections"
              [suggestions]="branchSuggestions"
              (completeMethod)="searchBranches($event)"
              [multiple]="true"
              field="name"
              dataKey="id"
              placeholder="Search branches"
              styleClass="w-full"
              inputStyleClass="w-full"
              [showClear]="true"
              [dropdown]="false"
              [appendTo]="'body'"
              [minLength]="1"
            ></p-autoComplete>
          </div>

          <div class="field col-12 md:col-6">
            <div class="flex align-items-center justify-content-between gap-3 mb-2">
              <label for="brands" class="font-medium block">Brands</label>
              <p-button
                type="button"
                label="Select All"
                icon="pi pi-check-square"
                styleClass="p-button-text p-button-sm"
                (onClick)="selectAllBrands($event)"
              ></p-button>
            </div>
            <p-autoComplete
              id="brands"
              formControlName="brandSelections"
              [suggestions]="brandSuggestions"
              (completeMethod)="searchBrands($event)"
              [multiple]="true"
              field="name"
              dataKey="id"
              placeholder="Search brands"
              styleClass="w-full"
              inputStyleClass="w-full"
              [showClear]="true"
              [dropdown]="false"
              [appendTo]="'body'"
              [minLength]="1"
            ></p-autoComplete>
          </div>

          <div class="field col-12 md:col-6">
            <div class="flex align-items-center justify-content-between gap-3 mb-2">
              <label for="customers" class="font-medium block">Customers</label>
              <p-button
                type="button"
                label="Select All"
                icon="pi pi-check-square"
                styleClass="p-button-text p-button-sm"
                [loading]="isCustomersLoading"
                (onClick)="selectAllCustomers($event)"
              ></p-button>
            </div>
            <p-autoComplete
              id="customers"
              formControlName="customerSelections"
              [suggestions]="customerSuggestions"
              (completeMethod)="searchCustomers($event)"
              [multiple]="true"
              field="name"
              dataKey="id"
              placeholder="Search customers by number or name"
              styleClass="w-full"
              inputStyleClass="w-full"
              [showClear]="true"
              [dropdown]="false"
              [appendTo]="'body'"
              [minLength]="1"
            >
              <ng-template let-customer pTemplate="item">
                <div class="flex flex-column">
                  <span class="font-medium text-900">{{ customer.name }}</span>
                  <small *ngIf="customer.customerNumber" class="text-600">{{ customer.customerNumber }}</small>
                </div>
              </ng-template>
            </p-autoComplete>
            <small class="text-600 block mt-2">
              This field loads results only when you search, so the full customer directory is not loaded on page open.
            </small>
          </div>

          <div class="field col-12 md:col-6">
            <div class="flex align-items-center justify-content-between gap-3 mb-2">
              <label for="suppliers" class="font-medium block">Suppliers</label>
              <p-button
                type="button"
                label="Select All"
                icon="pi pi-check-square"
                styleClass="p-button-text p-button-sm"
                (onClick)="selectAllSuppliers($event)"
              ></p-button>
            </div>
            <p-autoComplete
              id="suppliers"
              formControlName="supplierSelections"
              [suggestions]="supplierSuggestions"
              (completeMethod)="searchSuppliers($event)"
              [multiple]="true"
              field="name"
              dataKey="id"
              placeholder="Search suppliers"
              styleClass="w-full"
              inputStyleClass="w-full"
              [showClear]="true"
              [dropdown]="false"
              [appendTo]="'body'"
              [minLength]="1"
            ></p-autoComplete>
          </div>
        </div>
      </p-fieldset>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        styleClass="p-button-secondary"
        type="button"
        (onClick)="cancel()"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Update User' : 'Save User'"
        type="submit"
        [loading]="isSaving"
        [disabled]="userForm.invalid || isLoading"
      ></p-button>
    </div>
  </form>
</div>
